import { trackPromise} from 'react-promise-tracker';
import {HOST} from '../../constants/constants'

const GET_BLIPS_START = "GET_BLIPS_START";
const GET_BLIPS_SUCC = "GET_BLIPS_SUCC";
const GET_BLIPS_FAIL = "GET_BLIPS_FAIL";

export default function getBlips(userdata,project,pageNo,date) {
    console.log(pageNo)
    console.log(date)
    console.log(project.project_id)
    return (dispatch) => {
        dispatch(apiCallStart())
        trackPromise(
        fetch(HOST+'/api_handler.php?timestamp='+new Date().getTime(), {
                method: 'POST',
                headers: {
                    'gateway':'0',
                    'path':'text2speech/project/blips/list',
                    'method':'POST',
                    'token':userdata.token
                },
                body: JSON.stringify({
                    "project_id":project.project_id,
                    "date":(date == null) ? "0000-00-00" : date,
                    "page_no":pageNo,
                    "page_limit":"10",
                }),
            })
                .then((response) => {
                    // if (response.headers.get('content-type').match(/application\/json/)) {
                        return response.json();
                    // }
                    // return response;
                })
                .then((jsonresponse) => dispatch(apiCallSuccess(jsonresponse)))
                .catch((error) => dispatch(apiCallFail(error)))
        )
    }
}

function apiCallStart() {
    return {
        type: GET_BLIPS_START
    }
}

function apiCallSuccess(data) {
    return {
        type: GET_BLIPS_SUCC,
        data,
    }
}

function apiCallFail(error) {
    return {
        type: GET_BLIPS_FAIL,
        error
    }
}
